import {
    NOTIF_GET_USERS_SUCCESS,
    NOTIF_GET_NONUSERS_SUCCESS,
    NOTIF_COMPANIES_SUCCESS,
    NOTIF_GET_USERS_FAIL,
    NOTIF_CLEAR_USERS,
    NOTIF_CLEAR_NONUSERS,
    NOTIF_SET_DATA,
    NOTIF_TOGGLE_CHECKBOX_ON,
    NOTIF_TOGGLE_CHECKBOX_OFF,
    NONUSER_ADD,
    NONUSER_JOIN,
    NONUSER_DELETE,
    NONUSER_POP,
    SHOW_PROGRESS,
    HIDE_PROGRESS,
    SHOW_POPUP,
    HIDE_CUSTOM_NOTIFICATION_POPUP,
    SHOW_CUSTOM_NOTIFICATION_POPUP,
} from '../constants/action-types';

import {
    getApprovedCompaniesRequest,
    getUsersRequest,
    getNonUsersRequest,
    setNotificationsRequest,
    unsetNotificationsRequest,
    addNonUserRequest,
    deleteNonUserRequest,
    sendCustomNotificationRequest,
} from '../services/api';

export function getUsersList(id) {
    return dispatch => {
        dispatch({ type: SHOW_PROGRESS });
        getUsersRequest(id)
            .then(result => {
                dispatch({
                    type: NOTIF_GET_USERS_SUCCESS,
                    payload: result.data,
                });
                dispatch({ type: HIDE_PROGRESS });
            })
            .catch(error => {
                dispatch({
                    type: NOTIF_GET_USERS_FAIL,
                    error,
                });
                dispatch({ type: HIDE_PROGRESS });
            });
    };
}

export function getNonUsersList() {
    return dispatch => {
        dispatch({ type: SHOW_PROGRESS });
        getNonUsersRequest()
            .then(result => {
                dispatch({
                    type: NOTIF_GET_NONUSERS_SUCCESS,
                    payload: result.data,
                });
                dispatch({ type: HIDE_PROGRESS });
            })
            .catch(error => {
                dispatch({
                    type: NOTIF_GET_USERS_FAIL,
                    error,
                });
                dispatch({ type: HIDE_PROGRESS });
            });
    };
}

export function getAll(id) {
    return dispatch => {
        dispatch({ type: SHOW_PROGRESS });
        getUsersRequest(id)
            .then(result => {
                dispatch({
                    type: NOTIF_GET_USERS_SUCCESS,
                    payload: result.data,
                });
                dispatch({ type: HIDE_PROGRESS });
            })
            .catch(error => {
                dispatch({
                    type: NOTIF_GET_USERS_FAIL,
                    error,
                });
                dispatch({ type: HIDE_PROGRESS });
            });
    };
}

export function clearUsersList() {
    return dispatch => {
        dispatch({ type: NOTIF_CLEAR_USERS });
    };
}
export function clearNonUsersList() {
    return dispatch => {
        dispatch({ type: NOTIF_CLEAR_NONUSERS });
    };
}

export function getApprovedCompaniesList(cb) {
    return dispatch => {
        dispatch({ type: SHOW_PROGRESS });
        getApprovedCompaniesRequest()
            .then(result => {
                dispatch({
                    type: NOTIF_COMPANIES_SUCCESS,
                    payload: result.data,
                });
                if (typeof cb === 'function') {
                    cb(result.data.length ? result.data[0] : false);
                }
                dispatch({ type: HIDE_PROGRESS });
            })
            .catch(error => {
                console.log(error);
                dispatch({ type: HIDE_PROGRESS });
            });
    };
}

export const toggleCheckboxOn = (userType, params) => dispatch => {
    dispatch({
        type: NOTIF_TOGGLE_CHECKBOX_ON,
        userType,
        params,
    });
};

export const toggleCheckboxOff = (userType, params) => dispatch => {
    dispatch({
        type: NOTIF_TOGGLE_CHECKBOX_OFF,
        userType,
        params,
    });
};

export const setNotifications = (userType, data) => async dispatch => {
    dispatch({ type: SHOW_PROGRESS });
    try {
        await setNotificationsRequest(userType, data);

        dispatch({ type: NOTIF_SET_DATA });
        dispatch(toggleCheckboxOn(userType, data));
        dispatch({ type: HIDE_PROGRESS });
    } catch (error) {
        console.log(error);
        dispatch({ type: HIDE_PROGRESS });
    }
};

export const setNotificationsData =
    (userType, data, isShowConfirmation = false) =>
    async dispatch =>
        isShowConfirmation
            ? dispatch({
                  type: SHOW_POPUP,
                  popupProps: {
                      title: `Set ${data.type} notifications for all products`,
                      content: `You are about to set ${data.type} notifications for all products. Do you really want to do this?`,
                      isConfirm: true,
                      buttonAction: () => dispatch(setNotifications(userType, data)),
                  },
              })
            : dispatch(setNotifications(userType, data));

export const unsetNotifications = (userType, data) => async dispatch => {
    dispatch({ type: SHOW_PROGRESS });
    try {
        await unsetNotificationsRequest(userType, data);

        dispatch({ type: NOTIF_SET_DATA });
        dispatch(toggleCheckboxOff(userType, data));
        dispatch({ type: HIDE_PROGRESS });
    } catch (error) {
        console.log(error);
        dispatch({ type: HIDE_PROGRESS });
    }
};

export const unsetNotificationsData =
    (userType, data, isShowConfirmation = false) =>
    async dispatch =>
        isShowConfirmation
            ? dispatch({
                  type: SHOW_POPUP,
                  popupProps: {
                      title: `Unset ${data.type} notifications for all products`,
                      content: `You are about to unset ${data.type} notifications for all products. Do you really want to do this?`,
                      isConfirm: true,
                      buttonAction: () => dispatch(unsetNotifications(userType, data)),
                  },
              })
            : dispatch(unsetNotifications(userType, data));

export const addNonUser = (params, cb) => async dispatch => {
    dispatch({ type: SHOW_PROGRESS });
    dispatch({ type: NONUSER_ADD });
    try {
        const result = await addNonUserRequest(params);
        if (typeof cb === 'function') {
            cb(result.data);
        }
        dispatch(getNonUsersList());
        dispatch({ type: HIDE_PROGRESS });
    } catch (error) {
        console.log(error);
        dispatch({ type: HIDE_PROGRESS });
    }
};

export function joinNonUser(user) {
    return dispatch => {
        dispatch({
            type: NONUSER_JOIN,
            payload: user,
        });
    };
}

export function popNonUser(id) {
    return dispatch => {
        dispatch({
            type: NONUSER_POP,
            id,
        });
    };
}

export function deleteNonUser(id, cb) {
    return dispatch => {
        dispatch({
            type: SHOW_POPUP,
            popupProps: {
                title: 'Delete',
                content: 'Are you sure you want to delete this user?',
                isConfirm: true,
                buttonAction: () => {
                    dispatch({ type: SHOW_PROGRESS });
                    dispatch({ type: NONUSER_DELETE });
                    deleteNonUserRequest(id)
                        .then(result => {
                            if (typeof cb == 'function') cb(id);
                            dispatch({ type: HIDE_PROGRESS });
                        })
                        .catch(error => {
                            console.log(error);
                            dispatch({ type: HIDE_PROGRESS });
                        });
                },
            },
        });
    };
}

export function hideCustomNotificationPopup() {
    return {
        type: HIDE_CUSTOM_NOTIFICATION_POPUP,
    };
}
export function showCustomNotificationPopup() {
    return {
        type: SHOW_CUSTOM_NOTIFICATION_POPUP,
    };
}

export function sendCustomNotification(data) {
    return dispatch => {
        dispatch({ type: SHOW_PROGRESS });
        sendCustomNotificationRequest(data)
            .then(result => {
                dispatch({ type: HIDE_PROGRESS });
                dispatch({ type: HIDE_CUSTOM_NOTIFICATION_POPUP });
                dispatch({
                    type: SHOW_POPUP,
                    popupProps: {
                        title: 'SUCCESS',
                        content: 'Custom notification was sent successfully',
                    },
                });
            })
            .catch(error => {
                dispatch({ type: HIDE_PROGRESS });
                console.log(error);
            });
    };
}



// WEBPACK FOOTER //
// ./source/actions/notificationsActions.js